(function () {
  'use strict';

  var MENU_LABELS = {
    'link-list-12': 'Bedroom',
    'link-list-32': 'Living Room',
    'link-list-29': 'Dining Products',
    'link-list-15': 'Garden & Outdoor Furniture',
    'link-list-14': 'Bathroom',
    'link-list-18': 'Furniture',
    'link-list-3': 'Duvets & Accessories',
    'link-list-1': 'Bedding & Sheets',
    'link-list-21': 'Accessories & Decor',
    'link-list-24': 'Sitting',
    'link-list-2': 'Seat Cushions',
    'link-list': 'Pet Products',
    'link-list-20': 'Indoor Furniture',
    'link-list-19': 'Outdoor Furniture',
    'link-list-10': 'Milo',
    'link-list-9': 'Bean Bags',
    'link-list-7': 'Rocking Chair',
    'link-list-22': 'Decorative Throws & Cushions',
    'link-list-11': 'Mirrors',
    'link-list-25': 'Vases',
    'link-list-26': 'Macramé Wall Hangings',
    'link-list-27': 'Table Lamps',
    'link-list-28': 'Rugs & Kilims',
    'link-list-30': 'Candles & Diffusers'
  };

  function getStorefrontRoot() {
    var routes = window.T4Sroutes || {};
    var root = routes.storefront_root || routes.root_url || '/';
    if (root.length > 1 && root.charAt(root.length - 1) !== '/') {
      root += '/';
    }
    return root;
  }

  function getPageLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('ar') === 0) return 'ar';
    if (lang.indexOf('ku') === 0) return 'ku';
    if (lang.indexOf('en') === 0) return 'en';
    var root = getStorefrontRoot();
    if (root.indexOf('/en') === 0) return 'en';
    if (root.indexOf('/ku') === 0) return 'ku';
    return 'ar';
  }

  function clearMegaSessionCache() {
    try {
      Object.keys(sessionStorage).forEach(function (key) {
        if (key.indexOf('MegaT4s') !== -1 || key.indexOf('dataMega') !== -1 || key.indexOf('DropT4s') !== -1 || key.indexOf('dataDrop') !== -1) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      /* ignore */
    }
  }

  function clearStaleMegaCache() {
    try {
      var locale = getPageLocale();
      var cacheLocaleKey = 'ariikaMegaMenuLocale';
      var cacheVersionKey = 'ariikaMegaMenuCacheV';
      var cacheVersion = '2';
      var prevLocale = sessionStorage.getItem(cacheLocaleKey);
      var prevVersion = sessionStorage.getItem(cacheVersionKey);
      if (prevLocale === locale && prevVersion === cacheVersion) return;
      clearMegaSessionCache();
      sessionStorage.setItem(cacheLocaleKey, locale);
      sessionStorage.setItem(cacheVersionKey, cacheVersion);
    } catch (e) {
      /* ignore */
    }
  }

  function applyThemeStorefrontRoot() {
    if (!window.T4SThemeSP) return false;
    window.T4SThemeSP.root_url = getStorefrontRoot();
    return true;
  }

  function waitForThemeStorefrontRoot() {
    if (applyThemeStorefrontRoot()) return;
    var attempts = 0;
    var timer = window.setInterval(function () {
      if (applyThemeStorefrontRoot() || ++attempts > 240) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  function localizeMegaRoot(root) {
    if (!root || getPageLocale() === 'ar') return;

    root.querySelectorAll('.ariika-mega-egypt__sidebar-item[data-menu-handle]').forEach(function (btn) {
      var label = MENU_LABELS[btn.getAttribute('data-menu-handle')];
      if (!label) return;
      var labelEl = btn.querySelector('.ariika-mega-egypt__sidebar-label');
      if (labelEl) labelEl.textContent = label;
    });
  }

  function transformMegaRoot(root) {
    if (!root) return;

    var groups = root.querySelectorAll('[data-ariika-mega-group]');
    if (!groups.length) return;

    if (root.dataset.ariikaMegaReady === 'true') {
      localizeMegaRoot(root);
      return;
    }

    var shell = document.createElement('div');
    shell.className = 'ariika-mega-egypt';
    shell.setAttribute('data-ariika-mega-egypt', '');

    var sidebar = document.createElement('nav');
    sidebar.className = 'ariika-mega-egypt__sidebar';
    sidebar.setAttribute('role', 'navigation');
    sidebar.setAttribute('aria-label', 'Mega menu categories');

    var panels = document.createElement('div');
    panels.className = 'ariika-mega-egypt__panels';

    groups.forEach(function (group, index) {
      var btn = group.querySelector('.ariika-mega-egypt__sidebar-item');
      var panel = group.querySelector('.ariika-mega-egypt__panel');
      if (!btn || !panel) return;

      if (group.dataset.menuHandle) {
        btn.setAttribute('data-menu-handle', group.dataset.menuHandle);
      }

      sidebar.appendChild(btn);
      panels.appendChild(panel);

      if (index === 0) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.classList.add('is-active');
      }
    });

    shell.appendChild(sidebar);
    shell.appendChild(panels);

    groups.forEach(function (group) {
      group.remove();
    });

    var row = root.matches('.t4s-row') ? root : root.querySelector('.t4s-row');
    if (!row) row = root;

    var loading = row.querySelector('.t4s-loading--bg');
    if (loading) loading.remove();

    row.innerHTML = '';
    row.appendChild(shell);

    root.dataset.ariikaMegaReady = 'true';
    stripIsotopeFromLazy(root);
    localizeMegaRoot(root);
    bindSidebar(sidebar, panels);
    syncMegaAfterTransform(root);
  }

  function syncMegaAfterTransform(root) {
    if (!root) return;
    var megaItem = root.closest('.t4s-type__mega');
    if (!megaItem || !megaItem.classList.contains('is-action__hover')) return;
    pinMegaSubMenu(getMegaSubMenu(megaItem));
  }

  function stripIsotopeFromLazy(lazy) {
    if (!lazy) return;
    lazy.classList.remove('isotopet4s', 'isotopet4s-later', 'isotopet4s-enabled');
    lazy.removeAttribute('data-isotopet4s-js');
    lazy.style.removeProperty('height');
    lazy.style.removeProperty('min-height');
    lazy.style.removeProperty('max-height');

    lazy.querySelectorAll('.ariika-mega-egypt__card, .ariika-mega-egypt__panel, .ariika-mega-egypt__grid, .t4s-sub-column-item').forEach(function (node) {
      node.style.removeProperty('position');
      node.style.removeProperty('left');
      node.style.removeProperty('top');
      node.style.removeProperty('width');
      node.style.removeProperty('height');
      node.style.removeProperty('transform');
    });

    if (window.jQuery) {
      try {
        var $lazy = window.jQuery(lazy);
        if ($lazy.data('isotopet4s')) {
          $lazy.isotopet4s('destroy');
        }
      } catch (e) {
        /* ignore */
      }
    }
  }

  function bindSidebar(sidebar, panels) {
    var buttons = sidebar.querySelectorAll('.ariika-mega-egypt__sidebar-item');
    var panelList = panels.querySelectorAll('.ariika-mega-egypt__panel');

    function activate(index) {
      buttons.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-expanded', active ? 'true' : 'false');
      });
      panelList.forEach(function (panel, i) {
        var active = i === index;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    }

    buttons.forEach(function (btn, index) {
      btn.addEventListener('mouseenter', function () {
        activate(index);
      });
      btn.addEventListener('focus', function () {
        activate(index);
      });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        activate(index);
      });
    });
  }

  function scanMegas(scope) {
    var root = scope || document;
    root.querySelectorAll('.t4s-header-layout_ariika_egypt .t4s-type__mega .t4s-lazy_menu').forEach(function (lazy) {
      stripIsotopeFromLazy(lazy);
      if (lazy.querySelector('[data-ariika-mega-group]') || lazy.querySelector('[data-ariika-mega-egypt]')) {
        transformMegaRoot(lazy);
      }
    });
  }

  function updateMegaMenuTop() {
    var header = document.querySelector('.t4s-section-header');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--ariika-mega-menu-top', bottom + 'px');
    return bottom;
  }

  var megaMenuTimers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var unpinTimers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var MEGA_TRANSITION_MS = 240;

  function getMegaSubMenu(item) {
    if (!item) return null;
    var children = item.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList.contains('t4s-sub-menu')) return children[i];
    }
    return null;
  }

  function clearMegaMenuTimers(megaItem) {
    if (!megaItem || !megaMenuTimers) return;
    var timers = megaMenuTimers.get(megaItem);
    if (!timers) return;
    timers.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
    megaMenuTimers.delete(megaItem);
  }

  function cancelUnpinMegaSubMenu(subMenu) {
    if (!subMenu || !unpinTimers) return;
    var timer = unpinTimers.get(subMenu);
    if (!timer) return;
    window.clearTimeout(timer);
    unpinTimers.delete(subMenu);
  }

  function clearMegaPositionStyles(subMenu) {
    if (!subMenu) return;
    subMenu.style.removeProperty('position');
    subMenu.style.removeProperty('left');
    subMenu.style.removeProperty('right');
    subMenu.style.removeProperty('width');
    subMenu.style.removeProperty('max-width');
    subMenu.style.removeProperty('margin');
    subMenu.style.removeProperty('transform');
    subMenu.style.removeProperty('top');
    subMenu.style.removeProperty('height');
    subMenu.style.removeProperty('max-height');
    subMenu.style.removeProperty('background-color');
    subMenu.style.removeProperty('opacity');
    subMenu.style.removeProperty('visibility');
    subMenu.style.removeProperty('pointer-events');
    subMenu.style.removeProperty('z-index');
    subMenu.style.removeProperty('overflow');
  }

  function scheduleUnpinMegaSubMenu(subMenu) {
    if (!subMenu) return;
    cancelUnpinMegaSubMenu(subMenu);
    var timer = window.setTimeout(function () {
      if (unpinTimers) unpinTimers.delete(subMenu);
      var megaItem = subMenu.closest('.t4s-type__mega');
      if (megaItem && megaItem.classList.contains('is-action__hover')) return;
      unpinMegaSubMenu(subMenu);
    }, MEGA_TRANSITION_MS);
    if (unpinTimers) unpinTimers.set(subMenu, timer);
  }

  function closeAllMegaSubMenus(exceptSubMenu) {
    document.querySelectorAll('.t4s-header-layout_ariika_egypt .t4s-type__mega > .t4s-sub-menu').forEach(function (subMenu) {
      if (subMenu === exceptSubMenu) return;
      var megaItem = subMenu.closest('.t4s-type__mega');
      if (megaItem && megaItem.classList.contains('is-action__hover')) return;
      scheduleUnpinMegaSubMenu(subMenu);
    });
  }

  function pinMegaSubMenu(subMenu) {
    if (!subMenu) return;
    var megaItem = subMenu.closest('.t4s-type__mega');
    if (!megaItem || !megaItem.classList.contains('is-action__hover')) return;

    cancelUnpinMegaSubMenu(subMenu);
    closeAllMegaSubMenus(subMenu);
    updateMegaMenuTop();
    subMenu.classList.remove('is--center-screen');
    subMenu.classList.add('ariika-mega-is-fixed');
    clearMegaPositionStyles(subMenu);

    var lazy = subMenu.querySelector('.t4s-lazy_menu');
    stripIsotopeFromLazy(lazy);
  }

  function unpinMegaSubMenu(subMenu) {
    if (!subMenu) return;
    cancelUnpinMegaSubMenu(subMenu);
    subMenu.classList.remove('ariika-mega-is-fixed');
    clearMegaPositionStyles(subMenu);
  }

  function scheduleMegaMenuRefresh(megaItem) {
    if (!megaItem) return;
    clearMegaMenuTimers(megaItem);

    var lazy = megaItem.querySelector('.t4s-lazy_menu');
    if (!lazy) return;

    var timers = [0, 50, 120, 400, 700, 1000].map(function (delay) {
      return window.setTimeout(function () {
        if (!megaItem.classList.contains('is-action__hover')) return;
        stripIsotopeFromLazy(lazy);
        scanMegas(megaItem);
        pinMegaSubMenu(getMegaSubMenu(megaItem));
      }, delay);
    });

    if (megaMenuTimers) megaMenuTimers.set(megaItem, timers);
  }

  function syncOpenMegaMenus() {
    var activeItem = document.querySelector('.t4s-header-layout_ariika_egypt .t4s-type__mega.is-action__hover');
    if (!activeItem) {
      closeAllMegaSubMenus(null);
      return;
    }
    pinMegaSubMenu(getMegaSubMenu(activeItem));
  }

  function bindMegaMenuPosition() {
    var layout = document.querySelector('.t4s-header-layout_ariika_egypt');
    if (!layout) return;

    updateMegaMenuTop();
    window.addEventListener('resize', syncOpenMegaMenus, { passive: true });
    window.addEventListener('scroll', syncOpenMegaMenus, { passive: true });
    document.addEventListener('theme:hover', syncOpenMegaMenus);

    layout.querySelectorAll('.t4s-type__mega').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        pinMegaSubMenu(getMegaSubMenu(item));
        scheduleMegaMenuRefresh(item);
      });
      item.addEventListener('mouseleave', function () {
        clearMegaMenuTimers(item);
        scheduleUnpinMegaSubMenu(getMegaSubMenu(item));
      });
    });

    var navigation = layout.querySelector('.t4s-navigation');
    if (navigation) {
      navigation.addEventListener('mouseleave', function () {
        layout.querySelectorAll('.t4s-type__mega').forEach(function (item) {
          clearMegaMenuTimers(item);
        });
        closeAllMegaSubMenus(null);
      });
    }

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
          var item = mutation.target;
          if (!item.classList || !item.classList.contains('t4s-type__mega')) return;
          var subMenu = getMegaSubMenu(item);
          if (item.classList.contains('is-action__hover')) {
            pinMegaSubMenu(subMenu);
            scheduleMegaMenuRefresh(item);
          } else {
            clearMegaMenuTimers(item);
            scheduleUnpinMegaSubMenu(subMenu);
          }
        });
      });
      layout.querySelectorAll('.t4s-type__mega').forEach(function (item) {
        observer.observe(item, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  function init() {
    clearStaleMegaCache();
    applyThemeStorefrontRoot();
    scanMegas();
    bindMegaMenuPosition();

    document.addEventListener('mouseenter', function (e) {
      var mega = e.target.closest('.t4s-type__mega');
      if (!mega || !mega.closest('.t4s-header-layout_ariika_egypt')) return;
      pinMegaSubMenu(getMegaSubMenu(mega));
      scheduleMegaMenuRefresh(mega);
    }, true);

    var header = document.querySelector('.t4s-section-header');
    if (header && typeof MutationObserver !== 'undefined') {
      var pending = false;
      var observer = new MutationObserver(function (mutations) {
        var hasLazyMenu = false;
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('.t4s-lazy_menu')) {
              transformMegaRoot(node);
              return;
            }
            if (node.querySelector && node.querySelector('.t4s-lazy_menu, [data-ariika-mega-group]')) {
              hasLazyMenu = true;
            }
          });
        });
        if (!hasLazyMenu || pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          scanMegas(header);
        });
      });
      observer.observe(header, { childList: true, subtree: true });
    }
  }

  clearStaleMegaCache();
  waitForThemeStorefrontRoot();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
